import React from "react";
import styled from "styled-components";

export const SITE_WIDTH = 1280;
export const SITE_WIDTH_PX = `${SITE_WIDTH}px`;
export const BRAND_NAME = "Baumaschinen Brandlmeier";
export const DOMAIN = "baumaschinen-brandlmeier.de";
export const SITE_URL = `https://${DOMAIN}`;
export const TEL = "+4916094710937";
export const STREET = "Kaltenbrunn 3";
export const ZIP = 84186;
export const CITY = "Vilsheim";

type AComponentProps = {
    className?: React.HTMLAttributes<"a">["className"];
    preSlot?: React.HTMLAttributes<"a">["children"];
};

const InfoA = styled.a`
    hyphenate-character: " ";
`;

export function WebsiteLink({ className, preSlot }: AComponentProps) {
    return (
        <InfoA className={className} href={SITE_URL}>
            <>{preSlot}</>
            {DOMAIN}
        </InfoA>
    );
}

export function EmailLink({ className, preSlot }: AComponentProps) {
    return (
        <InfoA className={className} href={`mailto:christian@${DOMAIN}`}>
            <>{preSlot}</>
            christian&shy;@{DOMAIN}
        </InfoA>
    );
}

export function TelLink({ className, preSlot }: AComponentProps) {
    return (
        <InfoA className={className} href={`tel:${TEL}`}>
            <>{preSlot}</>
            +49 (0) 160 94710937
        </InfoA>
    );
}
